module.exports = __webpack_public_path__ + "img/pay-pal.6bd0311c.png";